import { Component, Input, OnInit } from '@angular/core';
import { ObtenerConsolidadoMS } from 'src/app/open-api';

@Component({
  selector: 'app-consolidated-invoice',
  templateUrl: './consolidated-invoice.component.html',
  styleUrls: ['./consolidated-invoice.component.scss']
})
export class ConsolidatedInvoiceComponent implements OnInit {

  @Input() consolidado?: ObtenerConsolidadoMS;

  constructor() { }

  ngOnInit(): void {
  }

}
